import { isUUID } from './is-uuid';

export type RecurringFeeFormulaFeeToken = {
  // `fees.<type>` covers every fee of a type, `fee.<id>` one fee
  scope: 'type' | 'id';
  key: string;
  withTax: boolean;
  // false when the token has a suffix other than `.withTax`, no key, or a
  // `fee.` key that is not a UUID
  valid: boolean;
};

// Recurring fee formula fields `fees.<type>` and `fee.<id>` take an optional
// `.withTax` suffix. Any other suffix is invalid, so later modifiers can be
// added without breaking formulas. Returns null for a field that is no fee token.
export function parseRecurringFeeFormulaFeeToken(
  value: string
): RecurringFeeFormulaFeeToken | null {
  const scope = value.startsWith('fees.')
    ? 'type'
    : value.startsWith('fee.')
      ? 'id'
      : null;
  if (!scope) return null;

  const [key, ...suffixes] = value.substring(value.indexOf('.') + 1).split('.');
  const withTax = suffixes[0] === 'withTax';
  return {
    scope,
    key: key ?? '',
    withTax,
    valid:
      Boolean(key) &&
      suffixes.length <= 1 &&
      (!suffixes.length || withTax) &&
      (scope === 'type' || isUUID(key)),
  };
}
